/* eslint-disable no-use-before-define */
/* eslint-disable no-useless-escape */
import { Encoder } from "./encoder"

export const SYMBOLS_REGEX =
  /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|`|-|{|}|\||\\/g //eslint-disable-line

export function regexIDCard() {
  const re = /^([0-9]{9}(?:[0-9]{3})?|[A-Za-z0-9]{5,9})$/
  return re
}

export function generateRandomString() {
  return Math.random().toString(36).substr(7)
}
export const getRegexPassword = () => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
  return regex
}
export function getRegexUsername() {
  const re = /^[a-zA-Z0-9_]{6,16}$/
  return re
}
export const regexStaffCode = /^[a-zA-Z0-9]+$/
export const regexStaffName =
  /^[a-zA-ZàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸĐ ]+$/
export const regexNumbText =
  /^[0-9a-zA-ZàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸĐ .,]+$/
export const regexNumbTextLower = /^[a-z0-9]+$/
export const regexBKS = /^[a-zA-Z0-9](?:[a-zA-Z0-9.-]*[a-zA-Z0-9])?$/

export function generateCode(str, underscore = true) {
  if (!str) return ""
  str = str?.toLowerCase()
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i")
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
  str = str.replace(/đ/g, "d")
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " ",
  )
  str = str.replace(/ + /g, " ")
  str = str.trim()
  str = str.toUpperCase()
  const matches = str.match(/\b(\w)/g)
  if (!matches) return ""
  const acronym = matches.join("")
  if (underscore) return `${acronym}_`
  return acronym
}

export function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function validatePhone(phone) {
  if (
    ((phone.startsWith("01") ||
      phone.startsWith("028") ||
      phone.startsWith("023") ||
      phone.startsWith("02")) &&
      phone.length === 11) ||
    ((phone.startsWith("03") ||
      phone.startsWith("05") ||
      phone.startsWith("07") ||
      phone.startsWith("08") ||
      phone.startsWith("09")) &&
      phone.length === 10)
  )
    return true
  return false
}

export function formatPhone(phone) {
  return phone.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3")
}

export function getMsgClient(message) {
  return message.indexOf("[!|") !== -1 && message.indexOf("|!]") !== -1
    ? message.split("[!|")[0].trim() + message.split("|!]")[1]
    : message
}

export function validateEmail(email) {
  const re = getRegexEmail()
  return re?.test(String(email)?.toLowerCase())
}

export function getRegexEmail() {
  const re = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/
  return re
}

export const validateEmailqt = value => {
  // Biểu thức chính quy để kiểm tra định dạng email cơ bản
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (!emailPattern.test(value)) {
    return false
  }
  // Kiểm tra tên miền hợp lệ
  const domainWhitelist = [
    "gmail.com",
    "yahoo.com",
    "outlook.com",
    "etstech.vn",
  ] // Ví dụ danh sách tên miền hợp lệ
  const domain = value.split("@")[1]
  return domainWhitelist.includes(domain)
}

export function validateMobile(mobile) {
  const re = getRegexMobile()
  return re?.test(String(mobile)?.toLowerCase())
}

export function getRegexBrandName() {
  const re = /^(?!.*[-_\\.\\s]{2})([a-zA-Z0-9-_\\.\\s]{0,10}[a-zA-Z0-9])?$/
  return re
}

export function getRegexPhoneNumber() {
  const re = /^(\+84|84|0)+(9|3|7|8|5)+([0-9]{8})\b/g
  return re
}

export function getRegexMobile() {
  const re = /^([0-9]{8,15})\b/g
  return re
}

export const decodeHtml = textInput => {
  if (!textInput) return ""
  const removeHtml = textInput.replace(/<\/?[^>]+(>|$)/g, "")
  const decode = Encoder.htmlDecode(removeHtml)
  return decode
}

export const stripHtml = textInput => {
  if (!textInput) return ""
  return textInput.replace(/<\/?[^>]+(>|$)/g, "")
}

export const convertContent = text => {
  let content
  try {
    const parseText = JSON.parse(decodeHtml(text))
    content = [parseText?.ActionName, parseText?.ProcessedContent]
      .join(parseText?.ActionName && parseText?.ProcessedContent ? ": " : "")
      .concat(
        parseText?.SendReportHandle ? ` ${parseText?.SendReportHandle}` : "",
      )
  } catch (e) {
    content = text
  }
  return content
}

export const fixImplicateText = text => {
  if (!text) return ""
  return text
    ?.replace(/↵/g, " ")
    ?.replace(/(<div>|<p>)/g, "&nbsp;<span>")
    ?.replace(/(<\/div>|<\/p>)/g, "</span>")
    ?.replace(/(<div |<p )/g, "&nbsp;<span ")
    ?.replace(/(<br>|<br\/>|<\/br>|<br \/>)/g, " ")
}

export function getTimeSpent() {
  const re = /^(d[g|h]?)?(d{1}?[05][m|p])?$/
  return re
}

export function formatUserName(fullName, userName, deptName) {
  if (!userName) return `${fullName} - ${deptName}`
  if (!deptName) return ` ${userName} - ${fullName} `
  return `${fullName} - (${userName}) - ${deptName}`
}

export function getRegexNumber() {
  const re = /^[0-9]+$/
  return re
}
export function getRegexNumberAcreage() {
  const re = /^\d+(\.\d+)?$/
  return re
}

export function isVietnamese(input) {
  // Biểu thức chính quy để kiểm tra ký tự tiếng Việt
  const vietnamesePattern =
    /[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸĐ]/
  return vietnamesePattern.test(input)
}

export function removeSpaces(input) {
  return input.replace(/\s+/g, "")
}

export function removeVietnameseTones(str) {
  // Chuyển thành chữ thường
  str = str.toLowerCase()
  // Thay thế các ký tự có dấu bằng ký tự tương ứng không dấu
  str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  // Thay thế các ký tự đặc biệt khác trong tiếng Việt
  str = str.replace(/đ/g, "d")
  // Loại bỏ các ký tự đặc biệt không mong muốn khác
  str = str.replace(/[^a-z0-9\s]/g, "")

  return str
}

export function containsNumberOrSpecialCharacter(input) {
  const hasNumber = /\d/
  const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/

  return hasNumber.test(input) || hasSpecialCharacter.test(input)
}

export function containsNumberOrSpecialCharacterExceptDotComma(input) {
  const hasNumber = /\d/
  const hasSpecialCharacter = /[!@#$%^&*()?":{}|<>]/

  return hasNumber.test(input) || hasSpecialCharacter.test(input)
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

